module.exports = __webpack_public_path__ + "static/img/icon-compatible-log.34ad45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/icon-compatible-log.png
// module id = WHTA
// module chunks = 57